import React from 'react';
import {
    ExtendedRiskActionFields,
    ExtendedRiskObservationFields,
} from '@pages-clean/risk-assessment/risk-log/constants';
import { NullableStudy } from '@contexts/local-state-context';
import { CompleteRiskFields } from '@queries/generated/fragments.generated';

export interface IFormData {
    study: NullableStudy | undefined;
    showDeleted: boolean;
    selectedObservation: ExtendedRiskObservationFields | undefined;
    selectedObservationRisk: CompleteRiskFields | undefined;
    selectedAction: ExtendedRiskActionFields | undefined;
    observationCount: number;
    actionCount: number;
    actionsGridIsFiltered: boolean;
    actionsGridFiltersResetToken?: number;
}

interface IContext {
    current: IFormData;
    setCurrent: React.Dispatch<React.SetStateAction<IFormData>>;
}

export const RiskMonitoringContext = React.createContext<IContext>(undefined!);
